<template>
  <div>
    <h6 class="mt-5 d-block text-center mb-3">
      {{ title }}
    </h6>
    <p class="text-center mb-4">
      {{ message }}
    </p>
    <p v-if="sellerPhoneNumber" class="text-center">
      Questions? Call me<br />
      <base-telephone :phone-number="sellerPhoneNumber" />
    </p>
  </div>
</template>

<script>
import Confetti from 'vue-confetti/src/confetti';
import BaseTelephone from '@/components/base-telephone';

const vueConfetti = new Confetti();

export default {
  name: 'VehicleTradeSuccess',
  components: {
    BaseTelephone,
  },
  props: {
    title: {
      type: String,
      default: 'Your trade-in is being evaluated',
    },
    message: {
      type: String,
      default: 'Thank you for sharing this information with us, we will be contacting you soon',
    },
    sellerPhoneNumber: {
      type: String,
      default: '',
    },
  },
  mounted() {
    this.handleConfetti();
  },
  destroyed() {
    vueConfetti.remove();
  },
  methods: {
    handleConfetti() {
      vueConfetti.start();

      setTimeout(() => {
        vueConfetti.stop();
      }, 2000);
    },
  },
};
</script>
